import { store } from "store";
import R from "ramda";
import {
  batchDownloadDocuments,
  batchUpdateDocuments,
  putDocument
} from "api/documents";
import { setFlashMessageAction } from "actions/app-actions";
import { pluralize } from "utils/string-helpers";

export const filterActionGenerator = (actionType, ajaxFunction, update) => (dispatch) => {
  dispatch({
    type: actionType,
    data: { update }
  });
  ajaxFunction(dispatch);
};

export const paginationActionGenerator = (actionType, ajaxFunction) => (dispatch) => {
  dispatch({
    type: actionType
  });
  ajaxFunction(dispatch, false);
};


export const documentViewedActionGenerator = (actionType, data) => (dispatch) => {
  const newDocument = R.clone(data.document);
  newDocument.viewed = true;
  return putDocument(data.accountId, data.document.id, newDocument)
    .then((response) => {
      dispatch({
        type: actionType,
        data: { document: response.data }
      });
    });
};

export const submitBatchEditActionGenerator = (
  actionTypeStart,
  actionTypeEnd,
  ajaxFunction,
  formName,
  page
) => (dispatch) => {
  dispatch({
    type: actionTypeStart
  });
  const state = store.getState();
  const account = state.app.selectedAccount;
  const formData = R.path(["form", formName, "values"], state);
  const documentIds = R.path([page, "selectedDocumentIds"], state);
  const documents = R.path([page, "documents"], state);
  const selectedDocuments = documentIds.map(id => documents.find(document => document.id === id));
  batchUpdateDocuments(account.id, selectedDocuments, formData)
    .then(() => ajaxFunction(dispatch, false))
    .then(() => {
      dispatch({ type: actionTypeEnd });
    })
    .catch(() => dispatch({ type: actionTypeEnd }));
};

export const batchDownloadsSharedAction = (dispatch, data, onStartAction, onEndAction) => {
  dispatch(onStartAction);
  return batchDownloadDocuments(data.exportType, data.account.id, data.documentIds, data.emails)
    .then(() => {
      dispatch(setFlashMessageAction(
        `A link will be sent to the email ${pluralize(data.emails.length, "addresses", "address", false)} shortly`
      ));
      dispatch(onEndAction());
    })
    .catch(() => {
      dispatch(setFlashMessageAction(
        "An unknown error occurred. Please try again in a few moments", "error"
      ));
      dispatch(onEndAction());
    });
};



// WEBPACK FOOTER //
// ./src/js/actions/shared/shared-action-generators.js